import React, { Fragment } from 'react';
import { withTranslation } from "react-i18next";
import NumberFormat from "react-number-format";
import NumberLoading from "./NumberLoading";

function Proposition(props) {

    return (
        <Fragment>
            <div className="wrapper__wrap">
                <h3 className="wrapper__wrap-heading ">
                    {props.title}
                    <br/>
                    <span className="wrapper__wrap-heading--highlight text-primary">
                        <NumberFormat thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType={"text"}
                                      value={props.amount}
                        /> {props.t('currency')}
                    </span>
                </h3>
            </div>
            <div className="wrapper__wrap">
                <h3 className="wrapper__wrap-heading">
                    {props.t('forms.monthly_payment')}
                    <br/>
                    <span className="wrapper__wrap-heading--highlight text-primary">
                        {props.monthly !== null ?
                            <span>
                            <NumberFormat thousandSeparator={'.'}
                                          decimalSeparator={','}
                                          displayType={"text"}
                                          value={props.monthly}
                            /> {props.t('currency')}
                            </span>
                            :
                            <NumberLoading postfix={props.t('currency')}/>
                        }
                    </span>
                </h3>
            </div>
            <div className="wrapper__wrap">
                <h3 className="wrapper__wrap-heading">
                    {props.t('term')}<br/>
                    <span className="wrapper__wrap-heading--highlight text-primary">
                        {props.term} {props.t('month')}
                    </span>
                </h3>
            </div>
            <div className="col-12 col-lg-12 d-flex align-items-center flex-column flex-lg-row">
                <button className="btn btn-primary btn-lg align-self-center btn-wrap mx-auto"
                        onClick={() => {
                            props.showSif({
                                amount: props.amount,
                                term: props.term
                            })
                        }}
                >
                    Noriu šios paskolos
                </button>
            </div>
            <div className="col-12 col-lg-12 d-flex align-items-center flex-column flex-lg-row">
                <p className="fake-link"
                   style={{margin: "10px auto"}}
                   onClick={() => {
                       props.showPreview({
                           amount: props.amount,
                           term: props.term
                       })
                   }}
                >
                    {props.t('preview')}
                </p>
            </div>
        </Fragment>
    );

}

export default withTranslation()(Proposition);
